var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.auditState,
                  callback: function($$v) {
                    _vm.auditState = $$v
                  },
                  expression: "auditState"
                }
              },
              [
                _c("el-radio", { attrs: { label: "1" } }, [_vm._v("通过")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: "-1" } }, [_vm._v("不通过")])
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.staffEnrollForm.staffComName))])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c("el-input", {
              model: {
                value: _vm.staffEnrollForm.staffNo,
                callback: function($$v) {
                  _vm.$set(_vm.staffEnrollForm, "staffNo", $$v)
                },
                expression: "staffEnrollForm.staffNo"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c("el-input", {
              attrs: { type: "text" },
              model: {
                value: _vm.staffEnrollForm.password,
                callback: function($$v) {
                  _vm.$set(_vm.staffEnrollForm, "password", $$v)
                },
                expression: "staffEnrollForm.password"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c("el-input", {
              attrs: { type: "textarea" },
              model: {
                value: _vm.staffEnrollForm.auditDesc,
                callback: function($$v) {
                  _vm.$set(_vm.staffEnrollForm, "auditDesc", $$v)
                },
                expression: "staffEnrollForm.auditDesc"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("审核信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("审核：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("机构信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("入职机构：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("其他信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("员工编号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("初始密码：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("审核备注：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b7b5ae2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b7b5ae2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/staffBiz/StaffEnrollFromAudit.vue
// module id = 3369
// module chunks = 0